import { apolloClient } from '@/setup/apollo-setup'
import { PUBLISH_SAMPLE_MESSAGE, SAMPLE_SUBSCRIPTION } from '@/queries/modules/sample'
import { error } from '@/utils/notification'

export async function subscribeSampleMessages(context) {
  context.commit('clearError')

  if (context.state.sampleSubscription && typeof context.state.sampleSubscription.unsubscribe === 'function') {
    context.state.sampleSubscription.unsubscribe()
  }

  context.commit('clearSampleSubscription')
  context.commit('setSampleMessages', [])

  try {
    const subscription = apolloClient.subscribe({
      query: SAMPLE_SUBSCRIPTION
    }).subscribe({
      next: ({data}) => {
        if (data && data.sampleSubscription) {
          context.commit('addSampleMessage', data.sampleSubscription)
        }
      },
      error: (err) => {
        context.commit('setError', error(err.message || err.toString(), null))
        subscription.unsubscribe()
        context.commit('clearSampleSubscription')
      }
    })

    context.commit('setSampleSubscription', subscription)
    context.commit('setSuccess', null)
  } catch (e) {
    context.commit('setError', error(e.toString(), null))
  }
}

export async function stopSampleSubscription(context) {
  if (context.state.sampleSubscription && typeof context.state.sampleSubscription.unsubscribe === 'function') {
    context.state.sampleSubscription.unsubscribe()
  }

  context.commit('clearSampleSubscription')
}

export async function publishSampleMessage(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    message: payload.message
  }

  try {
    const response = await apolloClient.mutate({
      mutation: PUBLISH_SAMPLE_MESSAGE,
      variables,
      fetchPolicy: 'no-cache'
    })

    const {data: {publishSampleMessage}} = await response

    if (!context.state.sampleSubscription) {
      context.commit('addSampleMessage', publishSampleMessage)
    }

    context.commit('setSuccess', null)
    return publishSampleMessage
  } catch (e) {
    context.commit('setError', error(e.toString(), null))
  }
}
